import type { Search } from "../../../../interfaces/Search";
import type { ResultItemProps } from "../ResultItem";
import { ResultItem } from "../ResultItem";

interface ServiceToResultItemProps {
  item: Search.Item;
  goToService: (url: string) => void;
}

export function SearchResultItem({ item, goToService }: Readonly<ServiceToResultItemProps>): JSX.Element {
  const onClick = goToService.bind(null, item.url);
  const props: ResultItemProps = { ...item, onClick };
  return <ResultItem {...props} />;
}
